import ScrollView from 'devextreme-react/scroll-view';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { hocSinhApi } from '../../api/hocsinh_api';
import PlaceHolder from '../../components/place-holder';
import styles from "./HocSinhProfile.module.css";
import DangKyDichVu from './dich-vu/DangKyDichVu';
import QuanHeGiaDinhHocSinh from './gia-dinh/QuanHeGiaDinhHocSinh';
import { GiayToNopForm } from './giay-to-nop';
import { HinhThucMienGiam } from './hinh-thuc-mien-giam';
import { HocSinhProfileListTab } from './list-tab';
import { hocSinhProfileTabs } from './list-tab/HocSinhProfileListTab';
import { HocSinhNameAndAvavtar } from "./name-and-avatar";
import { ProfileForm } from './profile-form';
import { TinhBaoPhi } from './tinh-bao-phi';
import { useSelector } from 'react-redux';
import { useCommonContext } from '../../contexts/common';


const HocSinhProfile = ({ value, height, phuHuynh, registerResult, onReloadData }) => {
    const { id } = useParams();
    const { translate } = useCommonContext();
    const [hocSinh, setHocSinh] = useState({ id: 0, is_edit_namhoc: true });
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState("profile");
    const componentDidMount = useRef(false);
    const { nam_hoc } = useSelector((x) => x.namHoc);
    useEffect(() => {
        if (value >= 0) {
            setHocSinh({ id: value })
        } else {
            setHocSinh({ id: parseInt(id) ?? 0 })
        }
    }, [value, id])
    useEffect(() => {
        componentDidMount.current = true;
        if (hocSinh.id > 0) {
            handleGetHocSinhData();
        }
        return () => {
            componentDidMount.current = false;
        }
    }, [hocSinh.id])
    const handleGetHocSinhData = async () => {
        setIsLoading(true);
        const res = await hocSinhApi.Detail(hocSinh.id, nam_hoc);
        if (!componentDidMount.current) return;
        setIsLoading(false);
        if (res.is_success) {
            setHocSinh(res.data);
        }
    }
    const hocSinhProfileTab = useMemo(() => {
        return hocSinhProfileTabs.find(x => x.id == selectedTab)
    }, [hocSinhProfileTabs, selectedTab])

    return (
        <div className={styles.container}>
            <div className={styles.left_side} style={{
                // height: window.innerHeight - 100
            }}>
                {isLoading && <PlaceHolder line_number={2} />}
                {!isLoading &&
                    <HocSinhNameAndAvavtar key={hocSinh.id} hocSinh={hocSinh} />
                }
                <HocSinhProfileListTab
                    selectedTab={selectedTab}
                    hocSinhId={hocSinh.id}
                    onTabSelectionChanged={(value) => { setSelectedTab(value) }}
                />
            </div>
            <div className={styles.right_side}>
                <div className={styles.right_side_container}>
                    <div className={styles.header}>{translate(hocSinhProfileTab.name)}</div>
                    <div className={styles.content}>
                        <ScrollView height={height ?? window.innerHeight - 170}>
                            <div>
                                {selectedTab == "profile" && <ProfileForm key={hocSinh.id} hocSinh={hocSinh}
                                    height={height ? height - 70 : (window.innerHeight - 170 - 70)}
                                    phuHuynh={phuHuynh}
                                    registerResult={registerResult}
                                    onSubmitSuccess={(id) => {
                                        if (hocSinh.id > 0) {
                                            handleGetHocSinhData();
                                        } else {
                                            setHocSinh({
                                                id: id
                                            })
                                        }
                                        if(registerResult && registerResult.id>0){
                                            onReloadData();
                                        }
                                    }}
                                />}
                                {selectedTab == "document" && <GiayToNopForm hocSinh={hocSinh} onUploadedAvatar={() => {
                                    handleGetHocSinhData();
                                }} />}
                                {selectedTab == "familly" && <QuanHeGiaDinhHocSinh hocSinh={hocSinh} phuHuynh={phuHuynh}/>}
                                {selectedTab == "discount" && <HinhThucMienGiam hocSinh={hocSinh} />}
                                {selectedTab == "service" && <DangKyDichVu hocSinh={hocSinh} height={height ? height - 70 : (window.innerHeight - 170 - 70)} />}
                                {selectedTab == "saleset" && <TinhBaoPhi hocSinh={hocSinh} height={height ? height - 70 : (window.innerHeight - 170 - 70)} />}

                                {/* {selectedTab == "care" && <LichSuCSKH hocSinh={hocSinh}/>} */}

                                {/* {selectedTab != "profile" && selectedTab != "document" &&
                        <div className={styles.no_data} style={{
                            height: window.innerHeight - 300
                        }}>
                            <img src='../../images/coming-soon.png' />
                            <p>Chưa có dữ liệu, vui lòng quay lại sau</p>
                        </div>
                    } */}
                            </div>
                        </ScrollView>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HocSinhProfile;